import { WaitForTransferringController } from './waitForTransferring.controller';
import template from './waitForTransferring.html';

export const waitForTransferringComponent = {
  name: 'waitForTransferringComponent',
  restrict: 'E',
  template,
  controller: WaitForTransferringController,
  controllerAs: 'vm',
  bindings: {
    aidRequest: '<'
  }
};
